import React, { useState, useEffect } from 'react'
import { Box, Typography, Button, ListItem, Chip, CardContent, Grid, Card, Avatar, CircularProgress } from '@material-ui/core'
import { baseApiUrl } from '../dataProvider/sails';
import Checkbox from '../checkbox'
import { makeStyles } from '@material-ui/core/styles'
import SelectBox from '../CustomizedUIs/CustomSelectBox'
import colors from '../CustomizedUIs/Colors'
import CustomPoper from '../CustomizedUIs/CustomPoper'
import DialogChooseFile from '../file-management/file-management-dialog'
import { useDataProvider, useTranslate, usePermissions } from 'react-admin'
import categories from '../categories'
import { Link } from "react-router-dom";
import { useHistory } from 'react-router-dom'
import TextField from '../CustomizedUIs/CustomTextFiled'
import { isAudio, isImage, isVideo } from '../utils';
import { red, pink } from '@material-ui/core/colors';
import CreateInSelect from '../CustomizedUIs/CreateInSelect';
import TextButton from '../CustomizedUIs/TextButton';

const bgColorError = pink['50'];
const textColorError = red['700'];

const useStyles = makeStyles(theme => ({

    borderImage: {
        borderRadius: '10px',
        backgroundColor: '#c1e5fa',
        '&:hover': {
            backgroundColor: '#a7cce7',
        }
    }
    , borderUpImange: {
        width: '500px',
        height: ' 145px',
        borderRadius: ' 10px',
        boxShadow: '0 5px 15px 0 rgba(0, 0, 0, 0.05)',
        backgroundColor: ' #ffffff',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: theme.palette.grey['200'],
        borderRightColor: theme.palette.grey['200'],
    },
    TitleImage: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.25,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    TextValue: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.385,
        letterSpacing: '0.13px',
        color: '#88898c',
    },
    
    large: {
        marginLeft: 16,
        border: '1px solid #ddd',
        borderRadius: 4,
        padding: 5,
        width: 150,
        height: 100,
        '&:hover': {
            boxShadow: '0 0 2px 1px rgba(0, 140, 186, 0.5)'
        }
    },
}));


const FormUpdate = ({ channelId, setChannelName }) => {
    const classes = useStyles()
    const dataProvider = useDataProvider()
    const { permissions, loaded } = usePermissions();
    const history = useHistory()
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [loading, setLoading] = useState(false)
    const [openPoper, setOpenPopper] = React.useState(false);
    const [openType, setOpenType] = useState(false)
    const [typeValue, setTypeValue] = useState('TV')
    const [openCategory, setOpenCategory] = useState(false)
    const [messsageError, setMessageError] = useState('')
    const translate = useTranslate()
    const [textValue, setTextValue] = useState({
        name: '',
        number: '',
        epgId: '',
        internalName: ''
    })
    const [error, setError] = useState({
        internalName: { status: false, messsage: '' },
        name: { status: channelId ? false : true, messsage: '' },
        number: { status: false, messsage: '' },
        epgId: { status: channelId ? false : true, messsage: '' }
    })

    const [url, setUrl] = useState('')
    const [logo, setLogo] = useState('')
    const [openFile, setOpenFile] = useState({
        status: false,
        defaultId: 1,
        format: '',
        setResponse: null
    })
    const [categories, setCategories] = useState([])
    const [isError, setIsError] = useState(channelId ? false : true)
    const [newCategory, setNewCategory] = useState('')
    const [openCreate, setOpenCreate] = useState(false)

    const createCategory = (value) => {
        dataProvider('CREATE', "channels/createcategory", {
            data: {
                name: value
            }
        })
            .then(({ data }) => {
                var temps = [...categories]
                temps.unshift(data)
                setCategories(temps)
                setNewCategory('')
                setOpenCreate(false)
            })
            .catch(error => {
                setNewCategory('')
                console.error('Create:', error);
            })
    }

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const handleOpenFileDialog = (type) => {
        setOpenFile({
            status: true,
            defaultId: type === 'logo' ? 4 : (typeValue === 'Radio' ? 7 : 6),
            format: type === 'logo' ? isImage : (typeValue === 'Radio' ? isAudio : isVideo),
            setResponse: type === 'logo' ? setLogo : setUrl
        })
    }

    const handleClose = () => {
        setOpenFile({
            status: false,
            defaultId: 1,
            format: '',
            setResponse: null
        })
    }


    const handleOpenType = () => {
        setOpenType(!openType)
    }

    const handleOpenCategory = () => {
        setOpenCategory(!openCategory)
    }
    const onChangeCheckBox = (index) => {
        let temps = categories.slice()
        temps[index].checked = temps[index].checked !== undefined ? !temps[index].checked : true
        setCategories(temps)
    }


    const getCategory = () => {
        //setLoading(true);
        dataProvider('GET_LIST', "channels/findcategory", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        }).then(({ data }) => {
            setCategories(data)
        }).catch(error => {
            console.error('Get list error:', error);
        });
    }


    const getCategoryAssign = () => {
        dataProvider('GET_LIST', "channels/findcategorybychannel", {
            filter: {
                channel: channelId
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        }).then(({ data }) => {
            setCategories(data)
        }).catch(error => {
            console.error('Get list error:', error);
        });
    }

    const onChangTextValue = (event, name) => {
        if (name === 'number') {
            if (!isNaN(event.target.value)) {
                setTextValue({
                    ...textValue, [name]: event.target.value.trim()
                })
                if (parseInt(event.target.value) > 65535)

                    setError({
                        ...error, [name]: { status: true, messsage: 'The maximum number is 65535' }
                    })
                else
                    setError({
                        ...error, [name]: { status: false, messsage: '' }
                    })
            }


        }
        else
            setTextValue({
                ...textValue, [name]: event.target.value
            })
        if (name === 'internalName' || name === 'name') {
            if (event.target.value === '' && name === 'name')
                setError({
                    ...error, [name]: { status: true, messsage: 'required' }
                })
            else if (event.target.value.length > 32)
                setError({
                    ...error, [name]: { status: true, messsage: 'Maximum of 32 characters are allowed' }
                })
            else
                setError({
                    ...error, [name]: { status: false, messsage: '' }
                })
        }
        if (name === 'epgId') {
            if (event.target.value.length > 32)
                setError({
                    ...error, [name]: { status: true, messsage: 'Maximum of 32 characters are allowed' }
                })
            else
                setError({
                    ...error, [name]: { status: false, messsage: '' }
                })
        }

    }

    const getChannel = () => {
        dataProvider('GET_ONE', "channels", {
            id: channelId

        }).then(({ data }) => {
            setTextValue({
                name: data.name,
                internalName: data.internalName,
                number: data.number < 0 ? '' : data.number,
                epgId: data.epgId
            })
            setTypeValue(data.type)
            setUrl(data.url)
            setLogo(data.logo)
            setChannelName(data.name)
        })
    }


    const onCreate = () => {
        setLoading(true)
        dataProvider('CREATE', "channels", {
            data: {
                name: textValue.name,
                internalName: textValue.internalName,
                type: typeValue,
                number: textValue.number === '' ? 0 : parseInt(textValue.number),
                epgId: textValue.epgId,
                categories: categories.filter(value => value.checked),
                url: url,
                logo: logo
            }
        }).then(({ data }) => {
            setLoading(false)
            history.push({
                pathname: '/channel',
                state: { open: true, name: textValue.name, message: translate(`pos.categories.createFolder.success`) }
            });
        })
            .catch(error => {
                setLoading(false)
                if (error.message === 'exist')
                    setMessageError('Name exist')
                else
                    setMessageError(error.message)
            })
        // .catch(error => {
        //     if (error.Error === 'nameExist')
        //         setMessageError('Name exist')
        //     else
        //         setMessageError(error)
        // });
    }

    const onEdit = () => {
        setLoading(true)
        dataProvider('UPDATE', "channels", {
            id: channelId,
            data: {
                name: textValue.name,
                internalName: textValue.internalName,
                type: typeValue,
                number: textValue.number === '' ? 0 : parseInt(textValue.number),
                epgId: textValue.epgId,
                categories: categories.filter(value => value.checked),
                url: url,
                logo: logo
            }
        }).then(({ data }) => {
            setLoading(false)
            history.push({
                pathname: '/channel',
                state: { open: true, name: textValue.name, message: translate(`pos.categories.editFolder.success`) }
            });
        })
            .catch(error => {
                setLoading(false)
                if (error.message === 'exist')
                    setMessageError('Name exist')
                else
                    setMessageError(error.message)
            })
    }

    const pickTypeValue = (value) => {
        if (value !== typeValue) {
            setTypeValue(value)
            setUrl('')
        }
        setOpenType(false)
    }

    useEffect(() => {
        setIsError(error.internalName.status || error.number.status || error.name.status)
    }, [error])

    useEffect(() => {
        if (channelId) {
            getCategoryAssign()
            getChannel()
        }
        else
            getCategory()
    }, [])

    if (!categories) return null
    if (!loaded) return null
    return (
        <Box>
            {
                messsageError != "" && (
                    <Box borderRadius='6px' my={1} width={500} bgcolor={bgColorError} py={1}>
                        <Typography variant='subtitle2' style={{ color: textColorError, margin: '1em' }}>{messsageError}</Typography>
                    </Box>
                )
            }
            <Box my={2}>
                <TextField
                    required
                    style={{ width: 500 }}
                    variant='filled'
                    label='Name'
                    error={error.name.status && error.name.messsage !== ''}
                    helperText={error.name.messsage}
                    onBlur={(event) => onChangTextValue(event, 'name')}
                    value={textValue.name}
                    onChange={(event) => onChangTextValue(event, 'name')}
                    endDom={<CustomPoper
                        open={openPoper}
                        anchorEl={anchorEl}
                        handleClick={handleClickOpenPoper}
                        handleClose={handleClosePoper}
                        title={translate(`pos.channels.channelNameTitle`)}
                        content={translate(`pos.channels.channelName`)}
                        icon={<b>?</b>}
                    />} />
            </Box>
            <Box my={2}>
                <TextField
                    style={{ width: 500 }}
                    variant='filled'
                    error={error.internalName.status && error.internalName.messsage !== ''}
                    helperText={error.internalName.messsage}
                    onBlur={(event) => onChangTextValue(event, 'internalName')}
                    label='Internal-Name'
                    value={textValue.internalName}
                    onChange={(event) => onChangTextValue(event, 'internalName')}
                    endDom={<CustomPoper
                        open={openPoper}
                        anchorEl={anchorEl}
                        handleClick={handleClickOpenPoper}
                        handleClose={handleClosePoper}
                        title={translate(`pos.channels.internalNameTitle`)}
                        content={translate(`pos.channels.internalName`)}
                        icon={<b>?</b>}
                    />} />
            </Box>
            <Box my={2}>
                <TextField
                    style={{ width: 500 }}
                    variant='filled'
                    label='Number'
                    value={textValue.number}
                    error={error.number.status && error.number.messsage !== ''}
                    helperText={error.number.messsage}
                    onBlur={(event) => onChangTextValue(event, 'number')}
                    onChange={(event) => onChangTextValue(event, 'number')}
                    endDom={<CustomPoper
                        open={openPoper}
                        anchorEl={anchorEl}
                        handleClick={handleClickOpenPoper}
                        handleClose={handleClosePoper}
                        title={translate(`pos.channels.channelNumberTitle`)}
                        content={translate(`pos.channels.channelNumber`)}
                        icon={<b>?</b>}
                    />} />
            </Box>
            <Box my={2}>
                <TextField
                    style={{ width: 500 }}
                    variant='filled'
                    label='Epg-id'
                    error={error.epgId.status && error.epgId.messsage !== ''}
                    helperText={error.epgId.messsage}
                    onBlur={(event) => onChangTextValue(event, 'epgId')}
                    value={textValue.epgId}
                    onChange={(event) => onChangTextValue(event, 'epgId')}
                    endDom={<CustomPoper
                        open={openPoper}
                        anchorEl={anchorEl}
                        handleClick={handleClickOpenPoper}
                        handleClose={handleClosePoper}
                        title={translate(`pos.channels.epgTitle`)}
                        content={translate(`pos.channels.epg`)}
                        icon={<b>?</b>}
                    />}
                />
            </Box>
            <Box my={2}>
                <SelectBox
                    label={'Type'}
                    value={<Typography className={classes.TextValue}>{typeValue}</Typography>}
                    open={openType}
                    handleClick={handleOpenType}
                    required={true}
                >
                    <ListItem className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickTypeValue('TV')}>
                        <Typography className={classes.TextValue}>{translate(`pos.dashboard.tv`)}</Typography>
                    </ListItem>
                    <ListItem className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickTypeValue('Radio')}>
                        <Typography className={classes.TextValue} >{translate(`pos.channels.radio`)}</Typography>
                    </ListItem>
                    <ListItem className={classes.boxBoder} style={{ padding: '8px' }} button onClick={() => pickTypeValue('Media')}>
                        <Typography className={classes.TextValue}>{translate(`pos.channels.media`)}</Typography>
                    </ListItem>
                </SelectBox>
            </Box>

            <Box my={2}>
                <SelectBox
                    label={translate(`pos.channels.categories`)}
                    value={
                        !categories || categories.filter(element => element.checked).length === 0 ? '' :
                            <Box display='flex'>
                                {
                                    categories.filter((element) => element.checked).map((data, index) => {
                                        if (index < 5)
                                            return (
                                                <Chip
                                                    color='primary'
                                                    size='small'
                                                    style={{ marginRight: 8 }}
                                                    key={data.id}
                                                    label={data.name}
                                                />
                                            )
                                    }
                                    )

                                }
                                {
                                    categories.filter((element, index) => element.checked).length > 5 && <Typography variant='body1'>{translate(`pos.channels.more`)}</Typography>
                                }

                            </Box>

                    }
                    open={openCategory}
                    handleClick={handleOpenCategory}
                    CreateBox={
                        <CreateInSelect
                            name={'category'}
                            valueInput={newCategory}
                            onChangValueInput={(e) => { setNewCategory(e.target.value) }}
                            handelCreateNew={createCategory}
                            openCreate={openCreate}
                            handelCancelCreate={() => setOpenCreate(false)}
                            clickOpenCreate={() => setOpenCreate(!openCreate)}
                        />}
                >
                    {
                        categories.map((data, index) => (
                            <ListItem onClick={() => onChangeCheckBox(index)} key={index} style={{ padding: '8px' }} button className={classes.boxBoder}>
                                <Checkbox color='primary' checked={data.checked === undefined ? false : data.checked}></Checkbox>
                                <Typography className={classes.TextValue}>{data.name}</Typography>
                            </ListItem>
                        ))
                    }

                </SelectBox>
            </Box>

            <Box my={2}>
                <Card style={{ marginTop: "1em" }} className={classes.borderUpImange} >
                    <Grid container style={{ marginTop: "1em" }} item xs={12} sm={12} xl={12} lg={12} >
                        <Grid>
                            {
                                logo && <img src={baseApiUrl + '/media/' + JSON.parse(logo).fd} className={classes.large} />
                            }

                        </Grid>
                        <Grid>
                            <CardContent>
                                <Typography className={classes.TitleImage} gutterBottom>
                                    {translate(`pos.user.changeimage`)}
                                </Typography>
                                <Box my={1}>
                                    <Button onClick={() => handleOpenFileDialog('logo')} className={classes.borderImage} color='primary'>{translate(`pos.channels.chooseLogo`)}</Button>
                                </Box>
                                {logo && <Typography style={{ width: 250, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>{`${JSON.parse(logo).filepath}`}</Typography>}
                            </CardContent>
                        </Grid>
                    </Grid>
                </Card>

            </Box>

            <Box my={2}>
                <TextField
                    style={{ width: 500 }}
                    variant='filled'
                    label='URI'
                    value={url === '' || typeValue !== 'Media' ? url : JSON.parse(url).filepath}
                    onChange={typeValue !== 'Media' ? (event) => { setUrl(event.target.value) } : () => { }}
                    endDom={
                        typeValue === 'Media' &&
                        <Button style={{ height: 30, marginLeft: 8 }} onClick={() => handleOpenFileDialog('media')} className={classes.borderImage} color='primary'>
                            {translate(`pos.channels.browse`)}
                        </Button>} />

            </Box>
            <Box my={2} display='flex' width='100%' justifyContent='flex-end' alignItems='flex-end'>
                <TextButton style={{ marginRight: '30px' }} component={Link} to={{ pathname: "/channel" }} />

                <Button disabled={isError || loading} style={{ pading: 8 }} variant='contained' color='primary' onClick={channelId ? onEdit : onCreate}>
                    {loading ? (
                        <CircularProgress
                            size={15}
                            thickness={2}
                            color='inherit'
                        />
                    ) :
                        channelId ? translate(`pos.common.save`) : translate(`pos.common.create`)
                    }
                    {/* {channelId ? translate(`pos.common.save`) : translate(`pos.common.create`)} */}
                </Button>
            </Box>
            <DialogChooseFile
                isSetPath={true}
                formats={openFile.format}
                defaultId={openFile.defaultId}
                open={openFile.status}
                pickerMode='pickMediaOnly'
                handleClose={handleClose}
                setChooseValue={openFile.setResponse}
                isPermission={permissions.functionAction.find((value) => value.function === 'File manager (CRUD)' && (value.isRead || value.isUpdate))}
            />
        </Box >
    )


}
export default FormUpdate